import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { MenuItemContainer, MenuItemTitle } from "./MenuItem.styled";
const MenuItem = (props) => {
    const { activePage, section, title, onToggleShowSubMenu, mainUrl, isMobile, textColor, backgroundColor, isExtraButton, } = props;
    const mainRedirect = useCallback(() => {
        mainUrl && window.open(mainUrl, "_self");
    }, [mainUrl]);
    return (_jsxs(MenuItemContainer, { active: activePage === section, onClick: (e) => {
            isMobile && !isExtraButton && onToggleShowSubMenu(e, true, section);
        }, onMouseEnter: (e) => !isMobile && onToggleShowSubMenu(e, true, section), onMouseLeave: (e) => !isMobile && onToggleShowSubMenu(e, false, section), backgroundColor: backgroundColor, "aria-label": `${title} menu item`, children: [_jsx(MenuItemTitle, { variant: "subtitle1", onClick: mainRedirect, textColor: textColor, "aria-label": `${title}`, children: title }), isMobile && _jsx(ArrowForwardRoundedIcon, { "aria-label": "forward arrow icon" })] }));
};
export { MenuItem };
//# sourceMappingURL=MenuItem.js.map